import { useHistory } from 'react-router-dom';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import { setLocalStorageItem } from '@commons/utils/localStorage';
import { user as userService } from '@services/user';
import mosAuth, { isMosLoginConfigured } from '@services/mosAuth';

/**
 * Post-OIDC InPulse bootstrap: resolve user via CORE (Bearer + introspection), then mark MOS session.
 * authProvider is set only after profile succeeds so a 401 does not trigger Mapal OS end-session.
 */
const MosComplete = () => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [errorDetail, setErrorDetail] = useState(null);

  useEffect(() => {
    const bootstrap = async () => {
      if (!isMosLoginConfigured()) {
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
        setErrorDetail('MOS OIDC is not configured (missing issuer/clientId).');

        return;
      }

      try {
        const hasToken = await mosAuth.hasMosAccessToken();

        if (!hasToken) {
          setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
          setErrorDetail('No MOS access token in storage after callback.');

          return;
        }

        // Fetch profile before markMosSession — APIcaller sends Bearer when MOS token exists.
        const profile = await userService.isAuthenticated();
        const userId = profile?.id;

        if (!userId) {
          setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
          setErrorDetail(
            'InPulse profile returned no user id. The MOS account may not be mapped in InPulse.',
          );

          return;
        }

        mosAuth.markMosSession();
        await setLocalStorageItem('userId', String(userId));

        const returnUrl = mosAuth.consumeMosReturnUrl();

        history.replace(returnUrl);
      } catch (err) {
        console.error('[MosComplete] bootstrap failed', err);
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
        setErrorDetail(err?.message || String(err));
      }
    };

    bootstrap();
  }, [history]);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        <p>{error}</p>
        {errorDetail && (
          <pre style={{ whiteSpace: 'pre-wrap', color: '#b00020', maxWidth: 640 }}>
            {errorDetail}
          </pre>
        )}
        <button type="button" onClick={() => history.replace('/login')}>
          {i18next.t('GENERAL.CONNECTION')}
        </button>
      </div>
    );
  }

  return null;
};

export default MosComplete;
